import { Button } from '@material-ui/core'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Context } from '../../../providers/ProjectContextProvider'
import FormContainer from '../../Form/FormContainer'

const PasswordRecoverySent = () => {
  const history = useHistory()
  const { setShowContactSupport } = useContext(Context)

  return (
    <>
      <div className="login flex">
        <div
          className="bg-image"
          style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
        ></div>
        <FormContainer>
          <h2>Link sent!</h2>
          <p className="fs14">
            Click the link in your inbox to reset your password and log back
            into your account. Don’t see an email from us? Check your spam
            folders or{' '}
            <span className="link" onClick={() => setShowContactSupport(true)}>
              contact support
            </span>
            .
          </p>

          <div className="flex flex-end m-t-40">
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push('/login')}
            >
              Return to sign in
            </Button>
          </div>
        </FormContainer>
      </div>
    </>
  )
}

export default PasswordRecoverySent
